import { default as domainTypeSubscription } from './type-subscription/store' 
import { default as domainTypeProcess } from './type-process/store'
import { default as domainDocumentType } from './document-type/store'
import { default as domainGroupSubscriber } from './group-subscriber/store'
import { default as domainUserSubscriber } from './user-subscriber/store'

export default { 
	domainTypeSubscription,
	domainTypeProcess,
	domainDocumentType,
	domainGroupSubscriber,
	domainUserSubscriber
}
